module.exports = __webpack_public_path__ + "static/media/desktop-icon-24-r-track-laptime.623dda9f.svg";